import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { DtFotaCampaignDetails, DtFotaCampaignDetailsModalProps } from '../../../../../types/FotaCampaigns';
import Modal from '../../../../../Common/Components/Modal';
import getHeaderProps from '../../../../../utils/getHeaderProps';
import Utils from '../../../../../utils/Utils';
import { ReactComponent as SyncIcon } from '../../../../../img/icons/sync.svg';
import Loading from '../../../../../Common/Components/Loading';
import Table from '../../../../../Common/Components/Table';

function DtFotaCampaignDetailsModal(props: DtFotaCampaignDetailsModalProps): JSX.Element {
  const { campaign, setOpenModal, getStateDot } = props;

  const headers = getHeaderProps('DtFotaCampaignDetails');
  const [dtFotaCampaignDetails, setDtFotaCampaignDetails] = useState<DtFotaCampaignDetails[]>();

  const { data: dtFotaCampaignDetailsResp, mutate: updateDtFotaCampaignDetails, isValidating } = useSWR<DtFotaCampaignDetails[]>(
    [`/fota/campaign/${campaign.campaignId}/details`, `GetDtFotaCampaignDetails-${campaign.campaignId}`],
  );

  useEffect(() => {
    if (dtFotaCampaignDetailsResp && dtFotaCampaignDetailsResp.length > 0) {
      setDtFotaCampaignDetails(dtFotaCampaignDetailsResp.map((item) => {
        const tableItem = { ...item };
        tableItem.opStatus = (tableItem.opStatus) ? 'True' : 'False';
        tableItem.started = (tableItem.started) ? Utils.getConvertedDate((new Date(tableItem.started))) : 'N/A';
        tableItem.lastUpdate = (tableItem.lastUpdate) ? Utils.getConvertedDate((new Date(tableItem.lastUpdate))) : 'No status updates yet';

        return tableItem;
      }));
    } else {
      setDtFotaCampaignDetails([]);
    }
  }, [dtFotaCampaignDetailsResp]);

  const [filteredTableData, setFilteredTableData] = useState([]);

  return (
    <Modal
      className="fota-campaign-details-modal"
      width="1230"
      height="660"
      setModalOpen={() => setOpenModal(0)}
      title={campaign.name}
      primaryButtonLabel="Close"
      primaryButtonAction={() => setOpenModal(0)}
      secondaryButtonLabel="Download CSV"
      secondaryButtonAction={() => Utils.downloadCSV(headers, filteredTableData || [], `dtfota-campaign-${campaign.name}`, true)}
      hasTable
    >
      <>
        {(!isValidating) && (
        <SyncIcon
          data-testid="icon"
          className="list-element__refresh refreshFotaCampaignDetails"
          onClick={() => {
            updateDtFotaCampaignDetails();
          }}
        />
        )}
        {(isValidating) && (
        <SyncIcon
          data-testid="icon"
          className="list-element__refresh refreshLoading refreshFotaCampaignDetails"
        />
        )}
      </>
      <div className="fota-campaign-details-header">
        <div>
          <div className="fota-campaign-details-header__nodes">
            <div>Nodes</div>
            <span>{campaign.numberOfNodes}</span>
          </div>
          <div className="fota-campaign-details-header__status">
            <div>Campaign status</div>
            <span>{getStateDot(campaign.state || '')}</span>
          </div>
          <div className="fota-campaign-details-header__enddate">
            <div>End date</div>
            {campaign.endDate ? Utils.getConvertedDate(new Date(campaign.endDate), 'LL/dd/yyyy') : 'N/A'}
          </div>
        </div>
      </div>
      <div className="fota-campaign-details-container">
        {(dtFotaCampaignDetails && Array.isArray(dtFotaCampaignDetails))
          ? (
            <div className="table table--light">
              <Table
                headers={headers}
                data={dtFotaCampaignDetails}
                setFilteredTableData={setFilteredTableData}
                dark={false}
                skipCellMeasure
              />
            </div>
          ) : (
            <Loading />
          )}
      </div>
    </Modal>
  );
}

export default DtFotaCampaignDetailsModal;
